const MANAGEMENT_ROLES = Object.freeze([
  'Admin',
  'Management',
  'SuperAdmin',
  'PageAdmin',
])

const ROLE_PERMISSIONS = Object.freeze({
  Blogger: ['Dashboard', 'Blogger', 'TagManager'],
  Accountent: ['Dashboard', 'Accountent'],
  Support: ['Dashboard', 'Support'],
  ProductManager: ['Dashboard', 'ProductManager', 'TagManager'],
  PhoneSupport: ['Dashboard', 'PhoneSupport'],
  SiteSupport: ['Dashboard', 'SiteSupport'],
  Designer: ['Dashboard', 'Designer'],
})

export const getAbilitiesForRole = role => {
  if (!role || typeof role !== 'string') return []

  const normalizedRole = role.trim()

  if (MANAGEMENT_ROLES.includes(normalizedRole)) {
    return [{ action: 'manage', subject: 'all' }]
  }

  return (ROLE_PERMISSIONS[normalizedRole] || []).map(permission => ({
    action: permission,
    subject: permission,
  }))
}

export const isManagementRole = role => (
  typeof role === 'string' && MANAGEMENT_ROLES.includes(role.trim())
)

